module.exports = __webpack_public_path__ + "img/fire.383908f5.png";